import { useEffect, useState } from "react";
import "./App.css";
import { SERVER_HOST, THEME_0, dataContext } from "./utils/constants";
import Dashboard from "./components/Dashboard";
import LoginForm from "./components/LoginForm";
import Loader from "./components/Loader";
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import UserRightsEdit from "./components/UserRightsEdit";

let allSettings = {};

const defaultItems = {
    // EndDate Statistics
    ordersStatistics: { show: true, label: "Статистика по замовленням" },
    cashBalances: { show: true, label: "Залишки коштів" },
    suppliersDebt: { show: true, label: "Борг постачальникам" },
    fiscalReport: { show: true, label: "Офіційні продажі" },
    paymentTypesDay: { show: true, label: "Види оплати (за день)" },
    stopList: { show: true, label: "Стоп-лист" },
    delimiter: { show: true, label: "---" },
    // Range Statistics
    salesReport: { show: true, label: "Статистика продажів" },
    efficiencyStatistics: { show: true, label: "Статистика ефективності" },
    paymentTypes: { show: true, label: "Види оплати" },
    peakHours: { show: true, label: "Пікові години" },
    popularMenu: { show: true, label: "Популярні страви" },
    // lossSoldGoods: { show: true, label: "Продажі в збиток" },
};

const getSettings = (username) => {
    let userSettings = localStorage.getItem(username);
    if (userSettings) allSettings = { ...allSettings, ...JSON.parse(userSettings) };
    return allSettings;
};

const setSettings = (data, username) => {
    allSettings = { ...allSettings, ...data };
    if (username && allSettings) {
        localStorage.setItem(username, JSON.stringify(allSettings));
    }
};

export default function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const [user, setUser] = useState({
        id: null,
        username: "",
        userRights: {},
        isAdmin: 0,
    });
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const [isDataUpdating, setDataUpdating] = useState(false);
    const [visibleItems, setVisibleItems] = useState({});
    const [pageContent, setPageContent] = useState("Dashboard");

    const handleDataUpdate = () => {
        setSidebarOpen(false);
        setDataUpdating(true);
    };

    const handleLogout = async () => {
        try {
            await fetch(SERVER_HOST, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({ action: "logout" }),
            });
            window.location.reload();
        } catch (error) {
            console.error("Logout error:", error);
        }
    };

    const changeTheme = (theme) => {
        let themeArray = Object.entries(theme);

        for (let i = 0; i < themeArray.length; i++) {
            document.documentElement.style.setProperty(themeArray[i][0], themeArray[i][1]);
        }
    };

    useEffect(() => {
        changeTheme(THEME_0);
        const checkSession = async () => {
            try {
                const response = await fetch(SERVER_HOST, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    credentials: "include",
                    body: JSON.stringify({ action: "check_session" }),
                });

                const data = await response.json();

                if (data.status === "logged_in") {
                    setUser({
                        id: data.user_id,
                        username: data.username,
                        userRights: data.userRights,
                        isAdmin: data.urAdmin,
                    });
                    setIsAuthenticated(true);

                    const userSettings = localStorage.getItem(data.username);
                    if (userSettings) setSettings(JSON.parse(userSettings), user.username);
                } else {
                    setIsAuthenticated(false);
                }
            } catch (error) {
                setIsAuthenticated(false);
            }
        };

        checkSession();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setDataUpdating(false);
    }, [isDataUpdating]);

    useEffect(() => {
        const userSettings = getSettings(user.username);
        setSettings(
            {
                ...userSettings,
                shef: { ...userSettings.shef, dashboardVisibleItems: visibleItems },
            },
            user.username
        );
        // eslint-disable-next-line
    }, [visibleItems]);

    useEffect(() => {
        if (!user.username) return;

        const userSettings = getSettings(user.username);
        const storedItems = userSettings?.shef?.dashboardVisibleItems;

        setVisibleItems(Object.keys(storedItems).length > 0 ? storedItems : defaultItems);
    }, [user.username]);

    if (isAuthenticated === null) {
        return <Loader />;
    }

    return isAuthenticated ? (
        <dataContext.Provider value={{ user }}>
            <Header toggleSidebar={() => setSidebarOpen(!isSidebarOpen)} />
            <Sidebar
                isOpen={isSidebarOpen}
                onClose={() => setSidebarOpen(false)}
                onLogout={handleLogout}
                visibleItems={visibleItems}
                setVisibleItems={setVisibleItems}
                handleDataUpdate={handleDataUpdate}
                openUserRightsEdit={() => {
                    setPageContent("UserRightsEdit");
                    setSidebarOpen(false);
                }}
            />
            {pageContent === "UserRightsEdit" && user.isAdmin ? (
                !isDataUpdating && <UserRightsEdit onBackToDashboard={() => setPageContent("Dashboard")} />
            ) : (
                !isDataUpdating && Object.keys(visibleItems).length > 0 && <Dashboard visibleItems={visibleItems} />
            )}
        </dataContext.Provider>
    ) : (
        <LoginForm />
    );
}
